// extracted by mini-css-extract-plugin
export const container = "year-select-module--container--3Veq_";
export const label = "year-select-module--label--2x1Zb";
export const select = "year-select-module--select--1EtPK";